import Vue from 'vue'
import Vuex from 'vuex'
import state from "./state"
import mutations from './mutations'

Vue.use(Vuex)

console.log()
export default new Vuex.Store({
    state,
    mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js